(() => {
  const root = document.querySelector('[data-maxsports-compare-root]');
  if (!root || window.maxSportsCompareInitialized) return;
  let config;
  try { config = JSON.parse(root.querySelector('[data-maxsports-compare-config]').textContent); }
  catch (_) { return; }
  const strings = config.strings;
  if (!strings || !strings.add || !strings.title) return;
  const localeRoot = new URL(config.root || '/', window.location.origin);
  if (localeRoot.origin !== window.location.origin) return;
  const path = localeRoot.pathname.replace(/\/?$/, '/');
  const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || config.currency;
  window.maxSportsCompareInitialized = true;

  const storageKey = 'maxsports.compare.v1';
  const tray = root.querySelector('[data-maxsports-compare-tray]');
  const items = root.querySelector('[data-maxsports-compare-items]');
  const openButton = root.querySelector('[data-maxsports-compare-open]');
  const clearButton = root.querySelector('[data-maxsports-compare-clear]');
  const dialog = root.querySelector('[data-maxsports-compare-dialog]');
  const closeButton = root.querySelector('[data-maxsports-compare-close]');
  const table = root.querySelector('[data-maxsports-compare-table]');
  const tableScroll = root.querySelector('[data-maxsports-compare-table-scroll]');
  const empty = root.querySelector('[data-maxsports-compare-empty]');
  const status = root.querySelector('[data-maxsports-compare-status]');
  const data = new Map();
  const requests = new Map();
  const titles = new Map();
  let opener;
  let controlsFrame;
  let fallbackInert = [];
  let focusRestoreSequence = 0;

  const validHandle = (value) => typeof value === 'string' && /^[\p{L}\p{N}][\p{L}\p{N}_-]{0,254}$/u.test(value);
  const selectionFrom = (value) => {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? [...new Set(parsed.filter(validHandle))].slice(0, 3) : [];
    } catch (_) { return []; }
  };
  let selected = [];
  try { selected = selectionFrom(window.localStorage.getItem(storageKey)); } catch (_) {}
  let lastSelectionHandle = selected.at(-1);
  let lastSelectionControl;
  const persist = () => {
    try { window.localStorage.setItem(storageKey, JSON.stringify(selected)); } catch (_) {}
  };
  const fill = (text, key, value) => (text || '').replace('{' + key + '}', value);
  const productURL = (handle) => path + 'products/' + encodeURIComponent(handle);
  const titleFor = (handle) => data.get(handle)?.product?.title || titles.get(handle) || handle;
  const trayTitleFor = (handle) => titleFor(handle)
    .replace(/^YONEX\s+/i, '')
    .replace(/^(?:ASTROX|ARCSABER|NANOFLARE)\s+/i, '');
  const thumbnailURL = (image, width) => {
    if (typeof image !== 'string') return null;
    try {
      const url = new URL(image, window.location.origin);
      const shopifyImage = url.hostname === 'cdn.shopify.com' ||
        url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/');
      if (!shopifyImage || !['https:', 'http:'].includes(url.protocol)) return null;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return null; }
  };
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const removeButton = (handle) => {
    const button = element('button', '×');
    button.type = 'button';
    button.dataset.maxsportsCompareRemove = handle;
    button.setAttribute('aria-label', fill(strings.remove, 'title', titleFor(handle)));
    return button;
  };

  const specNames = {
    flex: ['flex', 'flexibility', 'stiffness', 'rigidity', 'rigidité', 'flexibilité', '硬度', '中杆硬度', '拍杆硬度', '球拍硬度', '柔性'],
    balance: ['balance', 'balance point', 'point d’équilibre', "point d'équilibre", 'équilibre', '平衡', '平衡点'],
    weight: ['weight', 'weight / grip', 'weight grip size', 'weight / grip size', 'weights / grips', 'poids', 'poids / taille du manche', '重量', '重量 / 握把', '重量 / 握柄尺寸'],
    length: ['length', 'total length', 'longueur', '长度', '全长'],
    material: ['material', 'materials', 'frame', 'frame composition', 'shaft', 'shaft composition', 'matériau', 'matériaux', 'cadre', 'tige', 'composition de la tige', '材质', '材料', '拍框', '中杆', '拍杆', '拍杆材质'],
    tension: ['tension', 'string tension', 'recommended tension', 'stringing advice', 'tension du cordage', 'tension de cordage recommandée', '磅数', '建议磅数', '推荐磅数', '穿线磅数', '建议穿线磅数'],
    gauge: ['gauge', 'diameter', 'thickness', 'diamètre', 'épaisseur', '线径', '直径', '厚度']
  };
  const normalizeLabel = (label) => label.normalize('NFKC').toLowerCase().replace(/[\s_.\-–—:：/()]/g, '');
  const specKeys = new Map(Object.entries(specNames).flatMap(([key, labels]) => labels.map((label) => [normalizeLabel(label), key])));
  const specsFrom = (html) => {
    const source = new DOMParser().parseFromString(typeof html === 'string' ? html : '', 'text/html');
    source.querySelectorAll('script, style').forEach((node) => node.remove());
    const specs = {};
    const textOf = (node) => {
      const copy = node.cloneNode(true);
      copy.querySelectorAll('br').forEach((br) => br.replaceWith('; '));
      return copy.textContent;
    };
    const add = (label, value, sourceLabel = '') => {
      const key = specKeys.get(normalizeLabel(label.trim())) || specKeys.get(normalizeLabel(sourceLabel.trim()));
      const clean = value.replace(/\s+/g, ' ').trim();
      if (!key || !clean || clean.length > 400) return;
      const text = key === 'material' ? label.trim().replace(/[:：]\s*$/, '') + ': ' + clean : clean;
      if (!specs[key]) specs[key] = [];
      if (!specs[key].includes(text)) specs[key].push(text);
    };
    source.querySelectorAll('tr').forEach((row) => {
      const cells = Array.from(row.children).filter((cell) => cell.matches('th, td'));
      for (let i = 0; i + 1 < cells.length; i += 2) {
        add(textOf(cells[i]), textOf(cells[i + 1]), cells[i + 1].getAttribute('data-th') || '');
      }
    });
    source.querySelectorAll('dt').forEach((label) => {
      if (label.nextElementSibling?.matches('dd')) add(textOf(label), textOf(label.nextElementSibling));
    });
    source.querySelectorAll('p, li').forEach((row) => {
      const copy = row.cloneNode(true);
      copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
      copy.textContent.split('\n').forEach((line) => {
        const pair = line.trim().match(/^([^:：]{1,45})\s*[:：]\s*(.+)$/);
        if (pair) add(pair[1], pair[2]);
      });
    });
    return specs;
  };

  const formatPrice = (product) => {
    const min = Number.isFinite(product.price_min) ? product.price_min : product.price;
    const max = Number.isFinite(product.price_max) ? product.price_max : min;
    if (!Number.isFinite(min) || !Number.isFinite(max)) return strings.not_provided;
    const money = (value) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(value / 100); }
      catch (_) { return (value / 100).toFixed(2) + ' ' + (currency || ''); }
    };
    return min === max ? money(min) : money(min) + ' – ' + money(max);
  };
  const optionsFor = (product) => (Array.isArray(product.options) ? product.options : []).map((option, index) => {
    const name = typeof option === 'string' ? option : option.name;
    const values = Array.isArray(option.values) ? option.values : [...new Set((product.variants || []).map((variant) =>
      Array.isArray(variant.options) ? variant.options[index] : variant['option' + (index + 1)]).filter((value) => typeof value === 'string'))];
    if (!name || !values.length || name === 'Title' && values.length === 1 && values[0] === 'Default Title') return null;
    return name + ': ' + values.join(', ');
  }).filter(Boolean);

  const updateControls = () => {
    controlsFrame = 0;
    document.querySelectorAll('[data-maxsports-compare-handle]').forEach((button) => {
      const handle = button.dataset.maxsportsCompareHandle;
      if (!validHandle(handle)) return;
      if (button.dataset.maxsportsCompareTitle) titles.set(handle, button.dataset.maxsportsCompareTitle);
      const chosen = selected.includes(handle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(chosen));
      button.textContent = chosen ? strings.selected : strings.add;
      button.setAttribute('aria-label', (chosen ? strings.selected : strings.add) + ': ' + titleFor(handle));
    });
  };
  const canFocus = (node) => {
    if (!node?.isConnected || node.disabled || node.closest('[hidden], [inert]') ||
      node.tabIndex < 0 && !node.hasAttribute('tabindex') || !node.getClientRects().length) return false;
    const style = window.getComputedStyle(node);
    return style.visibility !== 'hidden' && style.visibility !== 'collapse';
  };
  const focusCard = (handle = lastSelectionHandle, preferred = lastSelectionControl) => {
    const controls = Array.from(document.querySelectorAll('[data-maxsports-compare-handle]'));
    const control = preferred?.dataset.maxsportsCompareHandle === handle && canFocus(preferred) ? preferred
      : controls.find((button) => button.dataset.maxsportsCompareHandle === handle && canFocus(button));
    if (control) { control.focus({ preventScroll: true }); return; }
    const headings = document.querySelectorAll('.collection-hero__title, #MainContent h1, #MainContent h2, #ProductGridContainer');
    const heading = Array.from(headings).find((node) => {
      if (!node.hasAttribute('tabindex')) node.setAttribute('tabindex', '-1');
      return canFocus(node);
    });
    const target = heading || Array.from(document.querySelectorAll('header a[href]')).find(canFocus);
    target?.focus({ preventScroll: true });
  };
  const measureTray = () => {
    const height = tray.hidden ? 0 : Math.ceil(tray.getBoundingClientRect().height);
    const value = height + 'px';
    if (document.body.style.getPropertyValue('--maxsports-compare-height') !== value) document.body.style.setProperty('--maxsports-compare-height', value);
  };
  const render = () => {
    const active = document.activeElement;
    const focusHandle = active?.dataset.maxsportsCompareRemove;
    const focusURL = active?.matches('a[href]') && active.getAttribute('href');
    const activeInDialog = dialog.contains(active);
    updateControls();
    tray.hidden = selected.length === 0;
    document.body.classList.toggle('maxsports-compare-active', selected.length > 0);
    openButton.textContent = fill(strings.open, 'count', selected.length);
    clearButton.disabled = selected.length === 0;
    items.replaceChildren(...selected.map((handle) => {
      const item = element('li');
      const model = element('span', trayTitleFor(handle), 'maxsports-compare-tray__model');
      model.setAttribute('aria-hidden', 'true');
      model.title = titleFor(handle);
      item.append(element('span', titleFor(handle), 'visually-hidden'), model, removeButton(handle));
      return item;
    }));
    tableScroll.hidden = selected.length === 0;
    empty.hidden = selected.length > 0;
    table.style.setProperty('--maxsports-compare-count', selected.length);
    table.setAttribute('aria-busy', String(selected.some((handle) => data.get(handle)?.status === 'loading')));
    const caption = element('caption', strings.title, 'visually-hidden');
    const head = element('thead');
    const headings = element('tr');
    const first = element('th', strings.model);
    first.scope = 'col';
    headings.append(first);
    selected.forEach((handle) => {
      const cell = element('th');
      cell.scope = 'col';
      const entry = data.get(handle);
      const product = entry?.status === 'ready' ? entry.product : null;
      const image = product && (product.featured_image || product.images?.[0]);
      const thumbnail = dialog.open && thumbnailURL(image, 240);
      if (thumbnail) {
        const img = element('img');
        img.src = thumbnail;
        img.srcset = thumbnail + ' 240w, ' + thumbnailURL(image, 360) + ' 360w';
        img.sizes = '120px';
        img.alt = '';
        img.width = 120;
        img.height = 120;
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        cell.append(img);
      }
      const link = element('a', titleFor(handle));
      link.href = productURL(handle);
      cell.append(link, removeButton(handle));
      if (entry?.status === 'error') {
        cell.append(element('p', strings.load_error));
        const retry = element('button', strings.retry);
        retry.type = 'button';
        retry.dataset.maxsportsCompareRetry = handle;
        cell.append(retry);
      } else if (!product) cell.append(element('p', strings.loading));
      headings.append(cell);
    });
    head.append(headings);
    const body = element('tbody');
    const rows = ['vendor', 'price', 'availability', 'options', 'flex', 'balance', 'weight', 'length', 'material', 'tension', 'gauge'];
    rows.forEach((key) => {
      const row = element('tr');
      row.dataset.compareField = key;
      const heading = element('th', strings[key]);
      heading.scope = 'row';
      row.append(heading);
      selected.forEach((handle) => {
        const entry = data.get(handle);
        const product = entry?.status === 'ready' ? entry.product : null;
        const cell = element('td');
        if (!product) cell.textContent = entry?.status === 'error' ? strings.not_provided : strings.loading;
        else if (key === 'vendor') cell.textContent = product.vendor || strings.not_provided;
        else if (key === 'price') cell.textContent = formatPrice(product);
        else if (key === 'availability') cell.textContent = typeof product.available === 'boolean'
          ? product.available ? strings.in_stock : strings.sold_out : strings.not_provided;
        else {
          const values = key === 'options' ? optionsFor(product) : entry.specs[key] || [];
          if (values.length) {
            const list = element('ul', undefined, 'maxsports-compare-options');
            values.forEach((value) => list.append(element('li', value)));
            cell.append(list);
          } else cell.textContent = strings.not_provided;
        }
        row.append(cell);
      });
      body.append(row);
    });
    const links = element('tr');
    const linkLabel = element('th', strings.view_product);
    linkLabel.scope = 'row';
    links.append(linkLabel);
    selected.forEach((handle) => {
      const cell = element('td');
      const link = element('a', strings.view_product, 'maxsports-compare-product-link');
      link.href = productURL(handle);
      cell.append(link);
      links.append(cell);
    });
    body.append(links);
    table.replaceChildren(caption, head, body);
    if (active && !active.isConnected) {
      const target = focusURL ? Array.from(dialog.querySelectorAll('a[href]')).find((link) => link.getAttribute('href') === focusURL)
        : Array.from((activeInDialog ? dialog : tray).querySelectorAll('[data-maxsports-compare-remove]'))
          .find((button) => button.dataset.maxsportsCompareRemove === focusHandle);
      if (target) target.focus();
      else if (dialog.open) closeButton.focus();
      else if (!tray.hidden) openButton.focus();
      else focusCard(focusHandle);
    }
    measureTray();
  };

  const fetchProduct = (handle, force = false) => {
    if (requests.has(handle)) return requests.get(handle);
    if (!force && data.get(handle)?.status === 'ready') return Promise.resolve();
    data.set(handle, { status: 'loading' });
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    const request = fetch(productURL(handle) + '.js', {
      method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal
    }).then((response) => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    }).then((product) => {
      if (!product || product.handle !== handle || typeof product.title !== 'string') throw new Error('Invalid product');
      data.set(handle, { status: 'ready', product, specs: specsFrom(product.description) });
    }).catch(() => { data.set(handle, { status: 'error' }); }).finally(() => {
      window.clearTimeout(timeout);
      requests.delete(handle);
      if (selected.includes(handle)) render();
    });
    requests.set(handle, request);
    return request;
  };
  const remove = (handle) => {
    selected = selected.filter((value) => value !== handle);
    persist();
    status.textContent = '';
    render();
  };
  const close = () => {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.body.classList.remove('maxsports-compare-open');
    table.querySelectorAll('img').forEach((image) => image.remove());
    fallbackInert.forEach(([node, inert]) => { node.inert = inert; });
    fallbackInert = [];
    const sequence = ++focusRestoreSequence;
    const restoreFocus = (frame) => {
      if (dialog.open || sequence !== focusRestoreSequence) return;
      const target = canFocus(opener) ? opener : canFocus(openButton) ? openButton : null;
      if (target) target.focus({ preventScroll: true });
      else if (frame < 3) window.requestAnimationFrame(() => restoreFocus(frame + 1));
      else if (!document.body.classList.contains('maxsports-overlay-open') &&
        !document.body.classList.contains('maxsports-chat-open')) focusCard();
    };
    restoreFocus(0);
  };
  const open = () => {
    if (!selected.length || dialog.open) return;
    focusRestoreSequence += 1;
    opener = document.activeElement;
    status.textContent = '';
    selected.forEach((handle) => fetchProduct(handle, true));
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else {
      dialog.setAttribute('open', '');
      dialog.setAttribute('aria-modal', 'true');
      fallbackInert = Array.from(document.body.children).filter((node) => node !== root)
        .map((node) => [node, node.inert]);
      fallbackInert.forEach(([node]) => { node.inert = true; });
    }
    document.body.classList.add('maxsports-compare-open');
    render();
    closeButton.focus();
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-maxsports-compare-handle]');
    if (control) {
      event.preventDefault();
      event.stopPropagation();
      const handle = control.dataset.maxsportsCompareHandle;
      if (!validHandle(handle)) return;
      if (selected.includes(handle)) remove(handle);
      else if (selected.length === 3) status.textContent = strings.limit;
      else {
        lastSelectionHandle = handle;
        lastSelectionControl = control;
        selected.push(handle);
        persist();
        status.textContent = '';
        fetchProduct(handle);
        render();
      }
      return;
    }
    const removed = event.target.closest('[data-maxsports-compare-remove]');
    if (removed) remove(removed.dataset.maxsportsCompareRemove);
    const retry = event.target.closest('[data-maxsports-compare-retry]');
    if (retry) { fetchProduct(retry.dataset.maxsportsCompareRetry, true); render(); }
  });
  openButton.addEventListener('click', open);
  clearButton.addEventListener('click', () => {
    const handle = selected.includes(lastSelectionHandle) ? lastSelectionHandle : selected.at(-1);
    selected = [];
    persist();
    status.textContent = '';
    render();
    focusCard(handle);
  });
  closeButton.addEventListener('click', close);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], [tabindex="0"]'))
      .filter((node) => !node.closest('[hidden]'));
    const first = focusable[0];
    const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey) return;
    selected = selectionFrom(event.newValue);
    selected.forEach((handle) => fetchProduct(handle));
    render();
  });
  new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => node.nodeType === 1 &&
      (node.matches('[data-maxsports-compare-handle]') || node.querySelector('[data-maxsports-compare-handle]'))))) return;
    if (!controlsFrame) controlsFrame = window.requestAnimationFrame(updateControls);
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', measureTray, { passive: true });
  if (window.ResizeObserver) new ResizeObserver(measureTray).observe(tray);
  updateControls();
  selected.forEach((handle) => fetchProduct(handle));
  render();
})();
